import type { AccessSession, AccessScope } from "@/content/types";

const STORAGE_KEY = "7md_access";

export function getSession(): AccessSession | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AccessSession;
  } catch {
    return null;
  }
}

export function setSession(session: AccessSession): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearSession(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}

export function hasScope(session: AccessSession | null, scope: AccessScope): boolean {
  return !!session?.scope.includes(scope);
}

export async function verifyToken(token: string): Promise<AccessSession> {
  const res = await fetch("/api/verify-token", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
  });
  if (!res.ok) {
    throw new Error(`invalid_token_${res.status}`);
  }
  return (await res.json()) as AccessSession;
}
